document.addEventListener('DOMContentLoaded', function() {
  const allImages = document.querySelectorAll('.product__media-item');

 function updateImages(selectedColor) {
  const allImages = document.querySelectorAll('.product__media-item');
  allImages.forEach(image => {
    const altText = image.querySelector('img')?.alt || '';
    if (altText.toLowerCase().includes(selectedColor.toLowerCase())) {
      image.style.display = 'block';
    } else {
      image.style.display = 'none';
    }
  });
}

  // 1. Initiale Farbfilterung beim Laden
 const variantSelect = document.querySelector('select[name="options[Farbe]"]');
if (variantSelect) {
  variantSelect.addEventListener('change', function() {
    const selectedColor = this.value;
    updateImages(selectedColor);
  });
}


  // 2. Filterung beim Wechsel der Variante
 document.addEventListener('variant:changed', function(event) {
  console.log('Variante geändert:', event.detail.variant);
  const selectedVariant = event.detail.variant;
  const selectedColor = selectedVariant.option1; // Passe dies an, falls 'Farbe' nicht die erste Option ist
  updateImages(selectedColor);
});
});

